export default {
    priKey:'24987b948f67cb52c2688bee7dd81804'
}



// WEBPACK FOOTER //
// ./src/service/constant/privateKey.js